import React, { useState } from 'react';

import { useExportTemplate, useStatusTemplates } from 'Templates';

import {
  Button,
  SidePage,
  Grid,
  Divider,
  DownloadIcon,
  DescriptionIcon,
  FileUploadIcon,
  Actions,
  Action,
} from '@gogame/components';
import { useChildComponent, useChooseFiles } from '@gogame/hooks-ts';

import {
  CategoryFormCreate,
  CategoryFormEdit,
} from 'scenes/Influencers/InfluencersChannels/components/CategoryForm';
import { TEMPLATE_NEW_INFLUENCER_CATEGORIES } from 'scenes/Influencers/InfluencersChannels/constants';
import {
  useLoadCategories,
  useUploadCategories,
  useExportCategories,
} from 'scenes/Influencers/InfluencersChannels/data';

import CategoryList from './CategoryList';
import SearchField from './SearchField';
import useFilterNormalize from './useFilterNormalize';

const Categories = ({ onClose, onExited, open }) => {
  const [exportCategoriesTemplate] = useExportTemplate({
    name: TEMPLATE_NEW_INFLUENCER_CATEGORIES,
  });
  const [uploadCategories] = useUploadCategories();
  const [exportCategories] = useExportCategories();
  const [childComponent, openChildComponent] = useChildComponent();
  const [searchFilter, setSearchFilter] = useState('');

  const { data = [], isLoading, isRefetching } = useLoadCategories();

  const dataNormalized = useFilterNormalize({
    data,
    searchFilter,
  });

  const handleAddCategory = () => {
    openChildComponent(CategoryFormCreate);
  };

  const handleEdit = ({ id }) => {
    openChildComponent(CategoryFormEdit, { id });
  };

  const handleExportTemplate = async () => {
    await exportCategoriesTemplate();
  };
  const handleExportCategories = async () => {
    await exportCategories();
  };

  const chooseSpreadsheet = useChooseFiles({
    accept: '.xlsx',
    multiple: false,
  });

  const handleUploadCategories = async () => {
    const file = await chooseSpreadsheet();
    await uploadCategories(file);
  };

  const templateUpdated = useStatusTemplates({
    name: TEMPLATE_NEW_INFLUENCER_CATEGORIES,
  });

  return (
    <SidePage
      onClose={onClose}
      onExited={onExited}
      loading={isLoading || isRefetching}
      open={open}
      size={'sm'}
    >
      <SidePage.Title
        title={'Categories'}
        actions={
          <Actions>
            <Action
              label={'Import'}
              icon={<FileUploadIcon />}
              onClick={handleUploadCategories}
            />
            <Action
              label={'Export'}
              icon={<DownloadIcon />}
              onClick={handleExportCategories}
            />
            <Action
              label={`Download template${templateUpdated ? ' (Updated)' : ''}`}
              icon={<DescriptionIcon />}
              badge={templateUpdated}
              onClick={handleExportTemplate}
            />
          </Actions>
        }
      />
      {data ? (
        <React.Fragment>
          <SidePage.NewBody fullHeight={false} scroll={false}>
            <Grid container spacing={1}>
              <Grid item xs={12} justifyContent={'space-between'}>
                <SearchField onChange={setSearchFilter} />
              </Grid>
              <Grid item xs={12}>
                <Button add onClick={handleAddCategory}>
                  Category
                </Button>
              </Grid>
            </Grid>
          </SidePage.NewBody>
          <Divider />
          <SidePage.NewBody scroll={false} disableGutters={true} dense={true}>
            <CategoryList
              data={dataNormalized}
              onEdit={handleEdit}
              filtered={!!searchFilter}
            />
          </SidePage.NewBody>
        </React.Fragment>
      ) : null}
      <SidePage.Actions>
        <SidePage.CloseButton />
      </SidePage.Actions>
      {childComponent}
    </SidePage>
  );
};

export default Categories;
